import { IconButton, Tooltip, Typography } from '@mui/material';
import moment from 'moment';

import { IcDotSpread } from '@/assets/images';
import { DATE_FORMAT } from '@/config';
import { formatPersonName } from '@/utils';

export const masterNameNoteCols = (openMenu: any) => ({
  description: () => ({
    renderCell: (params: any) => {
      const desc = (params?.row.description as string) ?? '';
      const displayText = desc.length > 25 ? `${desc.slice(0, 25)}...` : desc;

      return (
        <Tooltip title={desc.length > 25 ? desc : ''} arrow>
          <Typography variant="body2" noWrap sx={{ maxWidth: 300 }}>
            {displayText}
          </Typography>
        </Tooltip>
      );
    },
    sortComparator: (a: string, b: string) => {
      const aStr = (a || '').toLowerCase();
      const bStr = (b || '').toLowerCase();
      return aStr.localeCompare(bStr);
    },
  }),
  createdBy: () => ({
    renderCell: (params: any) => {
      const { firstName, lastName } = params.row.createdBy;
      return formatPersonName({ firstName, lastName }) || 'no name';
    },
    valueGetter: (_: any, row: any) => {
      const { firstName, lastName } = row.createdBy || {};
      return formatPersonName({ firstName, lastName });
    },
    sortComparator: (a: string, b: string) => {
      const aStr = (a || '').toLowerCase();
      const bStr = (b || '').toLowerCase();
      return aStr.localeCompare(bStr);
    },
  }),
  createdAt: () => ({
    renderCell: (params: any) =>
      moment(params.row.createdAt).format(DATE_FORMAT),
    valueGetter: (_: any, row: any) => {
      return row.createdAt ? moment(row.createdAt) : null;
    },
    sortComparator: (a: any, b: any) => {
      const dateA = a ? moment(a).toDate() : null;
      const dateB = b ? moment(b).toDate() : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return dateA.getTime() - dateB.getTime();
    },
  }),
  cfs: () => ({
    renderCell: (params: any) =>
      params.row.cfs
        ? params.row.cfs.number
        : params.row.kase
        ? params.row.kase.number
        : 'no number',
    valueGetter: (
      _: any,
      row: { cfs: { number: string }; kase: { number: string } },
    ) => (row.cfs ? row.cfs.number : row.kase ? row.kase.number : undefined),
    sortComparator: (a: string, b: string) => {
      const aStr = (a || '').toLowerCase();
      const bStr = (b || '').toLowerCase();
      return aStr.localeCompare(bStr);
    },
  }),
  actions: () => ({
    sortable: false,
    renderCell: (params: any) =>
      (params.row?.cfs?.number || params.row?.kase?.number) && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            openMenu(e, params.row);
          }}
        >
          <IcDotSpread />
        </IconButton>
      ),
  }),
});
